var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mutableShow) ? _c('div', {
    staticClass: "spnod-modal__mask"
  }, [_c('div', {
    staticClass: "spnod-modal__wrapper"
  }, [_c('div', {
    staticClass: "spnod-modal__container"
  }, [_c('div', {
    staticClass: "spnod-modal__header"
  }, [(_vm.hasClose !== 'false') ? _c('div', {
    staticClass: "spnod-modal__close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            x\n          ")]) : _vm._e(), _vm._v(" "), _vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "spnod-modal__body"
  }, [_c('long-form-h-t-m-l', {
    attrs: {
      "modalBody": _vm.modalBody
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spnod-modal__footer"
  }, [_c('form', {
    ref: _vm.formName,
    attrs: {
      "id": _vm.formName,
      "autocomplete": "off"
    }
  }, [_c('form-generator', {
    attrs: {
      "schema": _vm.schema
    },
    on: {
      "checkValues": function($event) {
        return _vm.checkValidity('signUpForm', $event)
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }), _vm._v(" "), _vm._t("action", function() {
    return [(_vm.hasCloseBtn) ? _c('button', {
      staticClass: "spnod-form__button spnod-button--primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.close.apply(null, arguments)
        }
      }
    }, [_vm._v("Close")]) : _vm._e()]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.hasInput === 'true') ? _c('div', {
    staticClass: "spnod-form__fieldset spnod-form__fieldset--no-background"
  }, [_c('label', {
    staticClass: "spnod-checkbox__label",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.mutableShow = true
      }
    }
  }, [_c('input', {
    staticClass: "spnod-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isChecked
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "spnod-radio__label spnod-radio__label--small"
  }, [_vm._v("Accept Terms and Conditions")])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spnod-radio--styled flaticon--center"
  }, [_c('span', {
    staticClass: "spnod-radio--checked fi2 flaticon2-checked-1 flaticon--white"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a72b609","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/CheckboxModal/CheckboxModal.vue
// module id = zZqA
// module chunks = 2